import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-statistic',
    templateUrl: './statistic.component.html',
    styleUrls: ['./statistic.component.css'],
    standalone: false
})
export class StatisticComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
